import React, { Fragment, useEffect, useState } from 'react'
import ReactModal from 'react-modal'
import { BrowserRouter as Router, Route, Link, Routes } from 'react-router-dom';
import axios from 'axios'
import Cookies from 'universal-cookie';
import RepresentanteLegal from './RepresentanteLegal/RepresentanteLegal';
import Gerente from './Gerente/GerenteInstitucion';
import InfoSedes from './Sedes/InfoSedes';
import MVInstitucion from './MVInstitucion';

function Consolidado(props) {
  const cookies = new Cookies();
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  return (

    <div className="test">
      <button variant="contained" className='btn btn-primary' color="primary" onClick={handleOpenModalTest} > Informacion de la institución</button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Solicitudes">

        <RepresentanteLegal idInstitucion={props.idInstitucion}/>
        <Gerente idInstitucion={props.idInstitucion}/>
        <InfoSedes idInstitucion={props.idInstitucion} />
        <MVInstitucion idInstitucion={props.idInstitucion}/>


      </ReactModal>

    </div>
  )
}

export default Consolidado